import { render } from "./SubscriptionPlansPage.vue?vue&type=template&id=23e6e7da"
import script from "./SubscriptionPlansPage.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlansPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__